import api from '../services/api'
import { Platform } from 'react-native'
import { hasDownloadedCustomLogo, RESET } from './game'

import FileSystem from '../lib/filesystem'

// Actions
const DOWNLOADING_START = 'ascension/downloading/fetching'
const DOWNLOADING_SUCCESS = 'ascension/downloading/success'
const DOWNLOADING_ERROR = 'ascension/downloading/error'

// Reducer
const initialState = {
  downloading: false,
  downloaded: false,
  error: null,
  filesToDownload: {}
}

const filesDownloaded = {}

const downloadDir = FileSystem ? FileSystem.documentDirectory : null

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case DOWNLOADING_START: {
      return {
        ...state,
        downloading: true,
        error: null,
        filesToDownload: action.data.reduce((acc, f) => {
          if (Platform.OS === 'web') {
            acc[f.name] = api.fetchFileUrl(f.url)
          } else {
            acc[f.name] = `${downloadDir}${f.md5}.png`
          }
          return acc
        }, {})
      }
    }
    case DOWNLOADING_SUCCESS: {
      return {
        ...state,
        downloaded: true,
        downloading: false,
        error: null
      }
    }
    case DOWNLOADING_ERROR: {
      return {
        ...state,
        downloaded: false,
        downloading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function downloadingStart (filesToDownload) {
  return {
    type: DOWNLOADING_START,
    data: filesToDownload
  }
}

export function downloadingSuccess () {
  return {
    type: DOWNLOADING_SUCCESS
  }
}

export function downloadingError (error) {
  return {
    type: DOWNLOADING_ERROR,
    data: error
  }
}

export function getDownloadedFiles () {
  return Object.keys(filesDownloaded)
}

export function getDownloadFilesObject () {
  return filesDownloaded
}

export async function initDownloadedFiles (store) {
  // console.log('Initing downloaded files')
  if (!FileSystem) {
    return
  }
  const content = await FileSystem.readDirectoryAsync(downloadDir)
  for (const file of content) {
    if (file.endsWith('.png') || file.endsWith('.pdf')) {
      const details = await FileSystem.getInfoAsync(`${downloadDir}${file}`, { md5: true })
      if (details.exists) {
        // should be able to delete this check at some stage once all devices no longer have the old named files on them
        if (file.includes(details.md5)) {
          filesDownloaded[details.md5] = true
        } else {
          filesDownloaded[file.replace('.png', '').replace('.pdf', '')] = true
        }
      }
    }
  }
}

export function downloadFiles (filesToDownload) {
  return async (dispatch, getState) => {
    if (!FileSystem) {
      dispatch(downloadingStart(filesToDownload))
      for (const file of filesToDownload) {
        if (file.name === 'logo.png') {
          dispatch(hasDownloadedCustomLogo(true))
        }
        filesDownloaded[file.md5] = api.fetchFileUrl(file.url)
      }
      dispatch(downloadingSuccess())
      return
    }
    if (getState().files.downloading) {
      // console.log('already downloaading, skippinng')
      return
    }
    dispatch(downloadingStart(filesToDownload))
    // console.log('Downloading files')
    // console.log('Already got', filesDownloaded)
    try {
      for (const file of filesToDownload) {
        if (filesDownloaded[file.md5]) {
          if (file.name === 'logo.png') {
            dispatch(hasDownloadedCustomLogo(true))
          }
          // console.log(`Already downloaded ${file.name}:${file.md5}, skipping`)
        } else {
          // console.log(`Havn't downloaded ${file.name}:${file.md5}, yet`)
          if (file.name === 'logo.png') {
            dispatch(hasDownloadedCustomLogo(false))
          }
          // try {
          //   await FileSystem.deleteAsync(`${downloadDir}${file.name}`)
          // } catch (err) {
          //   console.log('Error deleting file', err)
          // }
          try {
            const response = await FileSystem.downloadAsync(api.fetchFileUrl(file.url), `${downloadDir}${file.md5}.png`)
            if (response.status === 200) {
              filesDownloaded[file.md5] = true
              if (file.name === 'logo.png') {
                dispatch(hasDownloadedCustomLogo(true))
              }
              // console.log('Downloaded', file.name)
            } else {
              console.log('Error downloading file', response)
            }
          } catch (err) {
            console.log('Error downloading file', err)
          }
        }
      }

      for (const downloadedFile of Object.keys(filesDownloaded)) {
        const shouldBeThere = !!filesToDownload.find(f => f.md5 === downloadedFile)
        if (!shouldBeThere) {
          try {
            await FileSystem.deleteAsync(`${downloadDir}${downloadedFile}.png`)
            delete filesDownloaded[downloadedFile]
          } catch (err) {
            console.log('Error deleting file', err)
          }
        }
      }
      // console.log('Finished downloading')
      dispatch(downloadingSuccess())
    } catch (e) {
      console.log('Finished downloading with error', e)
      dispatch(downloadingError(e))
    }
  }
}

export function deleteFiles () {
  return async (dispatch) => {
    if (!FileSystem) {
      return
    }
    for (const file of Object.keys(filesDownloaded)) {
      try {
        // console.log('deleting', file)
        await FileSystem.deleteAsync(`${downloadDir}${file}.png`)
        delete filesDownloaded[file]
      } catch (err) {
        if (!err.message.includes('could not be found')) {
          console.log('error deleting file', err.message)
        }
      }
    }
    console.log(filesDownloaded)
    // dispatch(reset())
  }
}
